import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import IPartner from '../../interfaces/IPartner'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { partnerList } from '../../services/api'

interface PartnerContextState extends BaseContextState {
  partners: Array<IPartner> | null
}

export interface PartnerContextData extends PartnerContextState {
  resetErrors: Function,
  requestPartnerList: (args: SearchRequest) => void,
}

// Create context
const { Provider, Consumer } = createContext({} as PartnerContextData)

// Export consumer
export const PartnerConsumer = Consumer

export class PartnerProvider extends BaseContextProvider {
  state: PartnerContextState = {
    partners: null
  }

  /**
   * Make api request for partner list
   * 
   * @param {SearchRequest} payload 
   */
  requestPartnerList = (payload: SearchRequest) => {
    this.setState({
      fetching: true,
      error: null
    }, async () => {
      const response = await partnerList(payload)

      // Process our response
      this.processResponse(response, { 
        paginate: {
          destination: 'partners'
        },
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestPartnerList: this.requestPartnerList
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
